import React from 'react';
import { useData } from '../store/DataContext';
import { AdminDashboard } from './admin/AdminDashboard';
import { ReceptionDashboard } from './reception/ReceptionDashboard';
import { NursingDashboard } from './nursing/NursingDashboard';
import { ClinicianDashboard } from './clinician/ClinicianDashboard';
import { LaboratoryDashboard } from './laboratory/LaboratoryDashboard';
import { RadiologyDashboard } from './radiology/RadiologyDashboard';
import { PharmacyModule } from './pharmacy/PharmacyModule';
export const DashboardRouter: React.FC = () => {
  const {
    currentUser
  } = useData();
  if (!currentUser) return null;
  switch (currentUser.role) {
    case 'Administrator':
      return <AdminDashboard data-id="element-2819" />;
    case 'Reception':
      return <ReceptionDashboard data-id="element-2820" />;
    case 'Nursing':
      return <NursingDashboard data-id="element-2821" />;
    case 'Clinician':
      return <ClinicianDashboard data-id="element-2822" />;
    case 'Laboratory':
      return <LaboratoryDashboard data-id="element-2823" />;
    case 'Radiology':
      return <RadiologyDashboard data-id="element-2824" />;
    case 'Pharmacy':
    case 'Pharmacy Manager':
      return <PharmacyModule data-id="element-2825" />;
    default:
      return <div data-id="element-2826">Unknown role</div>;
  }
};